import { FETCH_EXCEL_FAIL, FETCH_EXCEL_REQUEST, FETCH_EXCEL_SUCCESS } from "../../ActionType/ExcelTypes/ExcelType";
import {
  FETCH_STATISTICS_FORM_FAIL,
  FETCH_STATISTICS_FORM_REQUEST,
  FETCH_STATISTICS_FORM_SUCCESS,
} from "../../ActionType/statisticsTypes/StatisticsTypes";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getStatisticsAction =
  (page, perPage, searchParam, searchQuery) => async (dispatch) => {

    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        searchParam,
        searchQuery,
        hospital: searchQuery.hospital || null,
        had_surgery: searchParam.surgery,
        medical: searchParam.medical,
        from_surgery: searchParam.from_surgery,
        to_surgery: searchParam.to_surgery,
        page,
        perPage,
      },
    };

    dispatch({
      type: FETCH_STATISTICS_FORM_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("statistics", config);
      const { status, data } = response;
      console.log("res : ",response)
      if (status == 200) {
        dispatch({
          type: FETCH_STATISTICS_FORM_SUCCESS,
          payload: { data: data.data, total: data.total },
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: FETCH_STATISTICS_FORM_FAIL,
        payload: [],
      });
    }
  };

export const exportData = (from, to) => async (dispatch) => {
  try {
    // console.log(from,to)
    // return
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        from,
        to
      },
      responseType: "blob", // Moved responseType to config
    };
    dispatch({
      type: FETCH_EXCEL_REQUEST,
    })

    const response = await api.get("statistics/export", config);
    // console.log(response)
    if (response.status == 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "output.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      dispatch({ type: FETCH_EXCEL_SUCCESS })
    }

  } catch (error) {
    dispatch({ type: FETCH_EXCEL_FAIL })

    console.error("Error exporting data:", error);
  }
};
